/**
 * Per-game asset root — design_docs/arctree_game_repos_and_asset_roots_15JUL26.md §3.
 *
 * Every loader that turns a game-content path into a network request routes
 * through resolveAssetUrl(). The rules:
 *
 *   1. Absolute stays absolute: a leading "/" (client-owned chrome/ etc.) or
 *      any scheme (data:, blob:, http(s):) passes through untouched.
 *   2. Everything else is game-owned and gets the current game's root
 *      prefixed. With no root set this degenerates to the pre-Phase-B
 *      behavior (path resolved against the web root) exactly.
 *
 * Phaser texture/audio cache keys stay the RAW relative path — only the URL
 * handed to the network is resolved — so save snapshots, rollback re-emits,
 * and cross-scene key references never see the root (or its version segment).
 *
 * Module-level mutable state is deliberate: one game plays per tab, and the
 * platform adapter's loadGame() is the single writer (same precedent as
 * ServerPlatform's cachedGames).
 */

let assetRoot = "";

const HAS_SCHEME = /^[a-z][a-z0-9+.-]*:/i;

export function setAssetRoot(base: string): void {
  assetRoot = base.replace(/\/+$/, "");
}

export function getAssetRoot(): string {
  return assetRoot;
}

export function resolveAssetUrl(path: string): string {
  if (!path || path.startsWith("/") || HAS_SCHEME.test(path)) return path;
  return assetRoot ? `${assetRoot}/${path}` : path;
}
